import { Box, Stack, Typography } from '@mui/material';
import { brandGradient } from '@/theme/palette';

/** Brand mark — gradient glyph, optionally followed by the wordmark. */
export default function Logo({ showWordmark = true, name = 'Content-Gen', size = 34 }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0 }}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: size * 0.28,
          background: brandGradient,
          display: 'grid',
          placeItems: 'center',
          color: '#fff',
          fontFamily: 'Sora, sans-serif',
          fontWeight: 800,
          fontSize: size * 0.5,
          flexShrink: 0,
          boxShadow: '0 6px 16px -6px rgba(124,58,237,0.6)',
        }}
      >
        C
      </Box>
      {showWordmark && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            noWrap
            sx={{ fontFamily: 'Sora, sans-serif', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.01em' }}
          >
            {name}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap sx={{ lineHeight: 1 }}>
            Media Studio
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
